module.exports = __webpack_public_path__ + "static/media/tram.48273a33.svg";